import { BrowserRouter as Router,
  Route,
  Switch
} from 'react-router-dom';

import 'bootstrap/dist/css/bootstrap.min.css';
import './styles/global.css';

import ScrollToTop from './components/scrollToTop';
import Preview from './pages/preview';
import MailSuccess from './pages/mailSuccess';
import Home01 from './pages/home/01';
import Home02 from './pages/home/02';
import BlogGrid01 from './pages/blogGrid/01';
import BlogGrid02 from './pages/blogGrid/02';
import BlogDetails from './pages/blogDetails';
import PageNotFound from './pages/pageNotFound';


const Routes = () => {
  return (
    <Router>
      <Switch>
        <Route path="/" exact component={Preview} />
        <Route path="/home01" exact component={Home01} />
        <Route path="/home02" exact component={Home02} />
        <Route path="/blog01" exact component={BlogGrid01} />
        <Route path="/blog02" exact component={BlogGrid02} />
        <Route path="/blog/details" exact component={BlogDetails} />
        <Route path="/mail" exact component={MailSuccess} />
        <Route component={PageNotFound} />
      </Switch>
      <ScrollToTop />
    </Router>
  );
};

export default Routes;